import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Colors } from '@gripp/shared-ui';
import { StyleSheet, Text, View } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { AddonAssignmentForm } from './addonAssignmentForm';

export const AddonMediaAssignmentButton = (data: any) => {
  const getLabel = (labelStyle: any, label: string) => {
    return <Text style={[labelStyle, styles.cellText]}>{label}</Text>;
  };

  return (
    <ModalButton
      label=""
      customButton={
        <View style={[styles.iconContainer]}>
          <MaterialCommunityIcons
            name="file-document"
            color={Colors.role.textPrimary}
            size={16}
            style={styles.icon}
          />
          {getLabel(styles.countText, data.mediaCount || '0')}
        </View>
      }
      modalComponent={({ onComplete }: { onComplete: () => void }) => (
        <AddonAssignmentForm
          addonId={data.addonId}
          title={data.addonName}
          onComplete={onComplete}
          initialTab="media"
        />
      )}
      containerStyle={styles.modalContainer}
    />
  );
};

const styles = StyleSheet.create({
  iconContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  icon: {
    marginRight: 2,
  },
  countText: {
    fontSize: 16,
    color: Colors.role.textStrong,
  },
  cellText: {
    fontSize: 16,
    fontWeight: '500',
    flexWrap: 'nowrap',
    color: Colors.role.textStrong,
  },
  modalContainer: {
    width: 640,
    height: '80%',
    minHeight: 450,
    alignSelf: 'center',
    backgroundColor: Colors.role.surfaceHover,
    borderRadius: 10,
  },
});
